import { useState } from 'react';
import Config from '../utils/config';
import {getFullUrlPath} from '../utils/common'; 

export default function useLanguage() {
    const [selectedLang, setSelectedLang] = useState(Config.appConfig.UserLang);
    const langList = Config.appConfig.LangList;
    const selectedLangName = langList.find(lang => lang.id === selectedLang).name;

    async function selectLang(e) {
        const target = e.target;
        const id = target.dataset.id;
        e.stopPropagation();
        setSelectedLang(id);

        const urlParams = new URLSearchParams(window.location.search);
        const webskintype = urlParams.get('webskintype') || '';

        const refreshPage = await Promise.resolve($.ajax(getFullUrlPath('ChangeLanguage.aspx'), {
            type: 'POST',
            data: { 
                hidSelLang: id, 
                hidIsLogin: Config.appConfig.Logined,
                webskintype: webskintype
            }
        }));
        window.location.href = getFullUrlPath(refreshPage);
    }

    return {
        selectedLang,
        selectedLangName,
        langList,
        selectLang
    };
}
